module.exports = __webpack_public_path__ + "static/media/CTLI_15-391w.e593e56d.jpg";